module.exports = __webpack_public_path__ + "media/recipes/130-a1fe958a.png";